
import ConsolidatedMeasurements from './ConsolidatedMeasurements'
import EventsMeasurements from './EventsMeasurements'

import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';

import Period from '../../../../helpers/Period';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

import { withRouter } from 'react-router-dom';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';


// Material components
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Popover from '@material-ui/core/Popover';
import DevicesIcon from '@material-ui/icons/Devices';
import LaptopMacIcon from '@material-ui/icons/LaptopMac';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import RefreshIcon from '@material-ui/icons/Refresh';
import TabletMacIcon from '@material-ui/icons/TabletMac';
import WarningSharpIcon from '@material-ui/icons/WarningSharp';
import CircularProgress from '@material-ui/core/CircularProgress';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import Switch from '@material-ui/core/Switch';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import InfoIcon from '@material-ui/icons/Info';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import { Doughnut } from 'react-chartjs-2';
import PerfectScrollbar from 'react-perfect-scrollbar';
import UpdateIcon from '@material-ui/icons/Update';
import Avatar from '@material-ui/core/Avatar';
import HelpIcon from '@material-ui/icons/Help';
import CloseIcon from '@material-ui/icons/Close';

// Component styles
import styles from './styles';
import Grid from '@material-ui/core/Grid';

import moment from 'moment-timezone'
import 'moment/locale/es'
import { getDefaultPeriod } from '../../../../utils/local-storage/select-periodo';
import { useTranslation, withTranslation } from 'react-i18next';
moment.locale('es')

const REFRESH_TIME = 300000

class Measurements extends Component {
    constructor(props) {
        super(props);
        var online = props.online;
        var statePeriod={}
        var period = 'd'
        this.handleConsolidatedMeasurementsClick = this.handleConsolidatedMeasurementsClick.bind(this);
        this.handleEventMeasurementsClick = this.handleEventMeasurementsClick.bind(this);
        this.handlePeriodClick = this.handlePeriodClick.bind(this);
        this.handleNextStepClick = this.handleNextStepClick.bind(this);
        this.handleInfo = this.handleInfo.bind(this);
        this.handleFirstInfo = this.handleFirstInfo.bind(this);
        this.handleDateMoment = this.handleDateMoment.bind(this);
        var typeGraph = 0;
        if (online === true ) {
            var typeGraph = 1
        }

        if (props.period === 'c' && online === true) {
            var period = 'c'
            var date = props.statePeriodMeasurements
            const begin=(moment(date.startDate)._d)
            const final= (moment(date.endDate)._d)
            statePeriod ={startDate: begin,endDate: final,key: "selection"}
        }
        this.translation = (this.props && this.props.t) ? this.props.t : (s => s);
        const t = this.translation;
        this.state = {
            typeGraph: typeGraph,
            period: period,
            step: 0,
            isForStep: false,
            nameStep: null,
            namePeriod: null,
            x: null,
            y: null,
            isLastEvent: false,
            objetive: this.props.match.params.objetivo_id,
            // statePeriod: {},
            statePeriod: statePeriod,
            isStatePeriod: false,
            tableEl: null,
            periodEl: null,
            typePeriod: 1,
            settingsEl: null,
            isRefresh: false,
            isInfo: null,
            checkedA: this.props.automaticUpdate,
            date: new Date(),
            dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, HH:mm:ss a")),
            isOneHour: true,
            detalleGraph:[t('monitoring.tools-section.dynamic-measurements-panel.modal.detalle-graph.text1'),
                        t('monitoring.tools-section.dynamic-measurements-panel.modal.detalle-graph.text2')],
            intervalId: null,
        };
    }

    componentDidMount() {
        if (this.props.automaticUpdate) {
            const newIntervalId = setInterval(
                () => this.tick(),
                this.props.refreshTime || REFRESH_TIME
            );
            this.setState({intervalId: newIntervalId})
        }
        const {appliedToAllSelected, parseSelectedGlobalPeriod} = getDefaultPeriod()
        if (this.props.globalPeriodValue !== undefined && !this.props.online && (appliedToAllSelected && parseSelectedGlobalPeriod)) {
            this.handlePeriodClick(null, this.state.typeGraph, parseSelectedGlobalPeriod.statePeriod, parseSelectedGlobalPeriod.value)
        }
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
    }
     
    tick() {
        if(this.state.checkedA===true){
            this.setState({
                date: new Date(),
                dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, HH:mm:ss a")),
                isRefresh: true,
            });
        }
    }

     handleChange = name=>event => {
        if (event.target.checked) {
            clearInterval(this.state.intervalId)
            const newIntervalId = setInterval(
                () => this.tick(),
                this.props.refreshTime || REFRESH_TIME
            );
            this.setState({intervalId: newIntervalId})
        }
        this.setState({ 
            checkedA: event.target.checked 
        });
      };


    handleConsolidatedMeasurementsClick() {
        this.setState({
            typeGraph: 0,
            isLastEvent: false,
            tableEl: null,
            isRefresh: false,
            isOneHour: false,
        });
    }

    handleEventMeasurementsClick() {
        this.setState({
            typeGraph: 1,
            isLastEvent: false,
            tableEl: null,
            isRefresh: false,
            isOneHour: false,
        });
    }

    handlePeriodClick(prevPeriod, prevTypeGraph, statePeriod, nextPeriod) {
        const t = this.translation;
        sessionStorage.setItem("measurementsSession",JSON.stringify({'nextPeriod':nextPeriod,'statePeriod':statePeriod}))
        if (nextPeriod === 'hora') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: 'h',
                typePeriod: 0,
                namePeriod: t('text.range') + ': ' + t('period.text.last-hour'),
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '3hora') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: '3h',
                typePeriod: 4,
                namePeriod: t('text.range') + ': ' + t('period.text.last-3-hours'),
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'dia') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "d",
                typePeriod: 1,
                namePeriod: t('text.range') + ': ' + t('period.text.last-day'),
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        }  else if (nextPeriod === '3dia') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "3d",
                typePeriod: 5,
                namePeriod: t('text.range') + ': ' + t('period.text.last-3-days'),
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'semana') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "w",
                typePeriod: 2,
                namePeriod: t('text.range') + ': ' + t('period.text.last-week'),
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'custom') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "c",
                typePeriod: 3,
                namePeriod: t('text.range') + ': ' + statePeriod.startDate.toISOString().substring(0, 10) + ' ' + t('text.to2') + ' ' + statePeriod.endDate.toISOString().substring(0, 10),
                statePeriod: statePeriod,
                isStatePeriod: true,
                periodEl: null,
                isRefresh: false
            });
        }
    }

    handleNextStepClick(propsStep, nextStep) {
        const prevPeriod = propsStep.period
        const prevTypeGraph = propsStep.typeGraph
        const newStep = nextStep
        if (propsStep.step !== newStep) {
            this.setState({
                typeGraph: prevTypeGraph,
                period: prevPeriod,
                step: newStep,
                isLastEvent: false
            })
        }
    }

    handleInfo(props, step) {
        this.setState({
            nameStep: step,
            x: props.x,
            y: props.y
        })
    }

    handleClose = event => {

        /*if (reason === 'clickaway') {
          	return;
        }
        this.setState({
            open: false 
        })*/
        this.props.onClose()
	};

    handleFirstInfo(props) {
        if (!this.state.isLastEvent && props.name !== null) {
            this.setState({
                nameStep: props.name,
                x: props.x,
                y: props.y,
                namePeriod: props.namePeriod,
                isLastEvent: true
            })
        }
    }
    handleDateMoment(props) {
        this.setState({
            dateMoment: props,
            isRefresh: false
        })
    }

    handleShowTables = event => {
        this.setState({
            tableEl: event.currentTarget
        });
    };

    handleCloseTables = () => {
        this.setState({
            tableEl: null
        });
    };

    handleShowPeriod = event => {
        this.setState({
            periodEl: event.currentTarget
        });
    };

    handleClosePeriod = () => {
        this.setState({
            periodEl: null
        });
    };

    handleRefresh = event => {
        this.setState({
            isRefresh: true,
            settingsEl: null,
        })
    }

    handleShowSettings = event => {
        this.setState({
            settingsEl: event.currentTarget
        });
    };
    handleShowIsInfo = event => {
        this.setState({
            isInfo: event.currentTarget
        });
    };
    handleCloseSettings = () => {
        this.setState({
            settingsEl: null
        });
    };
    handleCloseIsInfo = () => {
        this.setState({
            isInfo: null
        });
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.automaticUpdate !== this.props.automaticUpdate && prevProps.refreshTime === this.props.refreshTime) {
            if (this.props.automaticUpdate) {
                clearInterval(this.state.intervalId)
                const newIntervalId = setInterval(
                    () => this.tick(),
                    this.props.refreshTime || REFRESH_TIME
                );
                this.setState({
                    intervalId: newIntervalId,
                    checkedA: this.props.automaticUpdate
                })
            } else {
                this.setState({checkedA: this.props.automaticUpdate})
                clearInterval(this.state.intervalId)
            }
        }
        if (prevProps.refreshTime !== this.props.refreshTime && this.state.checkedA) {
            clearInterval(this.state.intervalId)
            const newIntervalId = setInterval(
                () => this.tick(),
                this.props.refreshTime || REFRESH_TIME
            );
            this.setState({
                intervalId: newIntervalId,
            })
        }

        if (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id) {
            this.setState({
                typeGraph: 0,
                period: this.state.period,
                step: this.state.step,
                isForStep: false,
                nameStep: null,
                x: null,
                y: null,
                isLastEvent: false,
                objetive: this.props.match.params.objetivo_id,
                periodEl: null
            })
        }
        if (this.props.globalPeriodValue) {
            if (prevProps.globalPeriodValue !== this.props.globalPeriodValue ||
                (this.props.globalPeriodValue === "custom" &&
                this.props.globalStatePeriod.startDate !== prevProps.globalStatePeriod.startDate)
            ) {
                this.handlePeriodClick(null, this.state.typeGraph, this.props.globalStatePeriod, this.props.globalPeriodValue)
            }
        }
    }

    render() {
        const { classes, className } = this.props;
        const { typeGraph, period, step, x, y, nameStep, statePeriod, isStatePeriod, namePeriod, tableEl, periodEl, online, 
            typePeriod, settingsEl, isRefresh,isInfo, detalleGraph,date, dateMoment, isOneHour } = this.state;

              
        let buttonConsolidated;
        let buttonEvent;
        const showTableEl = Boolean(tableEl);
        const showPeriodEl = Boolean(periodEl);
        const showSettingsEl = Boolean(settingsEl);
        const showIsInfo = Boolean(isInfo);

        buttonConsolidated = <ConsolidatedMeasurementsButton onClick={this.handleConsolidatedMeasurementsClick} />;
        buttonEvent = <EventMeasurementsButton onClick={this.handleEventMeasurementsClick} />;

        sessionStorage.setItem("nameMeasurements",JSON.stringify(namePeriod))

        const rootClassName = classNames(classes.root, className);
        const divStyle = {
            top: '25%',left: '21%', width:'500px'
          };
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        const namePeriodPortlet = [t('period.text.last-hour'), t('period.text.last-day'), t('period.text.last-week'), t('period.text.custom'), t('period.text.last-3-hours'), t('period.text.last-3-days')]
        const nameGraph = [t('monitoring.tools-section.dynamic-measurements-panel.modal.name-graph.text1'), t('monitoring.tools-section.dynamic-measurements-panel.modal.name-graph.text2')]
        return (
                <Portlet
                    /*  {...rest} */
                    /* style={{backgroundColor:"#656565"}} */
                    className={rootClassName}
                >
                    <PortletHeader className={classes.header}
                    >
                        <PortletLabel
                            /*  icon={<DevicesIcon />} */
                            variant="h6"
                            title={nameGraph[typeGraph]}
                        />

                        <PortletToolbar className={classes.portletToolbar}>
                            <IconButton
                                //className={classes.refreshButton}
                                //variant="text"
                                onClick={this.handleShowSettings}
                            >
                                <SettingsOutlinedIcon />
                                
                            </IconButton>
                            <Popover
                                anchorEl={settingsEl}
                                
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                onClose={this.handleCloseSettings}
                                open={showSettingsEl}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}>
                                <IconButton
                                    className={classes.refreshButton}
                                    variant="text"
                                    onClick={this.handleRefresh}
                                    onClose={this.handleCloseSettings}
                                >             
                                    <RefreshIcon color="infoIcon" /><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>{t('text.update')}</Typography>
                                </IconButton>
                                <IconButton
                                        onClick={this.handleShowIsInfo}
                                        onClose={this.handleCloseIsInfo}
                                    >
                                        <HelpIcon color="infoIcon"/><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>{t('monitoring.tools-section.dynamic-measurements-panel.modal.button.settings.tooltip')}</Typography>
                                </IconButton>
                                <Popover
                                    anchorEl={isInfo}
                                    open={showIsInfo}
                                    onClose={this.handleCloseIsInfo}
                                >
                                    <PortletContent variant="h4" style={{fontSize:'16px', color:'#66788A'}}>{detalleGraph[typeGraph]}</PortletContent>
                                </Popover>
                                <Tooltip title={t('text.auto-update')}>
                                    <div style={{textAlign:"center"}}>
                                        <Switch
                                            checked={this.state.checkedA}
                                            onChange={this.handleChange('checkedA')}
                                            value="checkedA"
                                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                                            color='primary'
                                        />
                                    </div>
                                </Tooltip>

                            </Popover>
                            <IconButton
                                onClick={this.handleShowTables}
                            >
                                <Typography 
                                    color="infoIcon"
                                    variant="h5">{t('monitoring.tools-section.dynamic-measurements-panel.modal.select.label')}</Typography>
                                <ArrowDropDownIcon />
                            </IconButton>
                            <IconButton key="close" aria-label="close" style={{color:"black"}} onClick={this.handleClose}><CloseIcon/></IconButton>
                            <Popover
                                anchorEl={tableEl}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center'
                                }}
                                onClose={this.handleCloseTables}
                                open={showTableEl}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center'
                                }}>
                                <div>
                                    {buttonConsolidated}<br />
                                    {buttonEvent}
                                </div>

                            </Popover>
                        </PortletToolbar>
                    </PortletHeader>
                    <PortletContent className={classes.content}>
                                <PerfectScrollbar>
                                    <div >
                                        {period == 'c' ?
                                            <div >
                                                <Typography   color="textSecondary" gutterBottom>
                                                    {t('text.from')} {statePeriod.startDate.toISOString().substring(0, 10)} {t('text.to')} {statePeriod.endDate.toISOString().substring(0, 10)}
                                                </Typography>
                                            </div>
                                        : null}
                                        {<Graph
                                            typeGraph={typeGraph}
                                            period={period}
                                            step={step}
                                            onInfo={this.handleInfo}
                                            onFirstInfo={this.handleFirstInfo}
                                            statePeriod={statePeriod}
                                            isStatePeriod={isStatePeriod}
                                            isRefresh={isRefresh} 
                                            date={date}
                                            onDateMoment={this.handleDateMoment}/>}
                                        
                                    </div>
                                    <div style={{float:"right", marginTop:"5%"}}>
                                        <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}>
                                                {/* <Typography >
                                               Última actualización:
                                               </Typography> */}
                                                
                                            <Avatar variant="rounded" className={classes.rounded}>
                                            <UpdateIcon /> 
                                            </Avatar>
                                            <Typography className={classes.updateTime}   >
                                                    &nbsp; {t('text.last-update')}: {dateMoment} 
                                            </Typography>
                                            
                                        </div>
                                    </div>                                                
                                </PerfectScrollbar>
                    </PortletContent>
                    <PortletFooter className={classes.portletFooter}>
                        <Button  variant="h4" style={{fontSize:'15px',float:'left'}} onClick={this.handleShowPeriod}>
                            {namePeriodPortlet[typePeriod]}<ArrowDropDownIcon style={{color:"#66788A"}}/>
                        </Button>
                        <Popover
                            anchorEl={periodEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center'
                            }}
                            onClose={this.handleClosePeriod}
                            open={showPeriodEl}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center'
                            }}>
                            <Period onClick={this.handlePeriodClick} period={period} typeGraph={typeGraph} isOneHour={true} />
                        </Popover>
                       
                    </PortletFooter>
                </Portlet>

        )
    }
}

function Graph(props) {
    const typeGraph = props.typeGraph;
    if (typeGraph === 0) {
        return <ConsolidatedMeasurements params={props} />;
    }
    if (typeGraph === 1) {
        return <EventsMeasurements params={props} />;
    }
}

function ConsolidatedMeasurementsButton(props) {
    const { t } = useTranslation()
    return (
        <Button onClick={props.onClick}>
            {t('monitoring.tools-section.dynamic-measurements-panel.modal.select.option.summary')}
      </Button>
    );
}

function EventMeasurementsButton(props) {
    const { t } = useTranslation()
    return (
        <Button onClick={props.onClick}>
            {t('monitoring.tools-section.dynamic-measurements-panel.modal.select.option.events')}
      </Button>
    );
}

export default
    compose(withRouter, withStyles(styles), withTranslation())(Measurements);

    